import React from 'react';

const LinkButton = (props) => {
  const ignoreLinkStyle = props.ignoreLinkStyle ? 'transparent' : 'default';
  const ignorePaddingMargin = props.ignorePaddingMargin ? '' : 'no-padding-margin';
  const fullWidth = props.fullWidth ? 'full-width' : '';
  const additional = props.id ? { id: props.id } : {};
  return (
    <button // eslint-disable-line react/button-has-type
      className={`link-button ${ignoreLinkStyle} ${props.classContent} ${ignorePaddingMargin} ${fullWidth}`}
      onClick={props.onClick}
      title={props.title}
      type={props.buttonType}
      aria-label={props.ariaLabel}
      {...additional}
    >
      {props.children}
    </button>
  );
};

LinkButton.defaultProps = {
  onClick: () => {},
  classContent: '',
  title: '',
  children: null,
  ariaLabel: '',
  ignoreLinkStyle: false,
  ignorePaddingMargin: false,
  fullWidth: false,
  buttonType: 'button',
};

export default LinkButton;
